
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"40","height":"40","viewBox":"0 0 40 40"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M32.967 36.683V29.25","fill":"none","stroke":"#fed029","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2"}}),_c('path',{attrs:{"data-name":"Vector","d":"M9.667 13.75h8.25M9.667 20h8.25M13.75 36.667v-6.25","fill":"none","stroke":"#fed029","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2"}}),_c('path',{attrs:{"data-name":"Vector","d":"M1.667 36.667h36.667M33 18.15a3.656 3.656 0 00-3.667 3.667V25.6a3.667 3.667 0 007.333 0v-3.783A3.656 3.656 0 0033 18.15zM3.5 36.667V10.05c0-3.35 1.667-5.033 4.983-5.033h10.384c3.317 0 4.967 1.683 4.967 5.033v26.617","fill":"none","stroke":"#5d3ebd","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2"}})])
          )
        }
      }
    